import React from "react";

export const paiseFmt = (p) => `₹${(p / 100).toLocaleString("en-IN")}`;
export const paiseFmt2 = (p) =>
  `₹${(p / 100).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

// Mirrors backend integer-paise math (floor); preview only — backend is authoritative.
export const customerPreview = (feeRupees, marginRupees, gstBps, expensesRupees = 0) => {
  const marginP = Math.round(Number(marginRupees || 0)) * 100;
  const ex = Math.round(Number(feeRupees || 0)) * 100 + marginP;
  const gst = Math.floor((ex * gstBps) / 10000);
  const contribution = marginP - Math.round(Number(expensesRupees || 0)) * 100;
  return { ex, gst, inc: ex + gst, contribution };
};

export const ContributionCell = ({ paise, testId }) => (
  <span className={`font-bold tabular-nums ${paise < 0 ? "text-rose-600" : "text-emerald-700"}`} data-testid={testId}>
    {paise < 0 ? `−₹${(Math.abs(paise) / 100).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : paiseFmt2(paise)}
  </span>
);
